module.exports = __webpack_public_path__ + "static/media/send-red.5df6a92d.png";